import AOS from 'aos';
import 'aos/dist/aos.css';

// Global
import './global/nav';

// Utilities
import footerPosition from './utility/footer-position';
import hamburger from './utility/hamburger';
import './utility/headroom';


/**
 * Manages components that should load dynamically (only when they are required)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  if (document.querySelector('.image-video')) {
    import('./blocks/image-video/image-video');
    import('./global/youtube-player-api').then(component => {
      component.default.outputScripTag();
    });
  }

  if (document.querySelector('.case-study__link-title')) {
    import('./blocks/hero/case-study');
  }

  if (document.querySelector('.statistics__slides')) {
    import('./blocks/carousels/statistics');
  }

  if (document.querySelectorAll('.four-stats__number').length) {
    import('./blocks/statistics/four-stats');
  }

  if (document.querySelector('.process-sequence')) {
    import('~scripts/blocks/process-sequence');
  }

  if (document.querySelector('.sub-service-sec')) {
    import('~scripts/blocks/sub-services-component');
  }

  if (document.querySelector('.growth-plan-sec')) {
    import('~scripts/blocks/growth-plans');
  }
    
  if (document.querySelector('.static-logos')) {
    import('~scripts/blocks/static-logos');
  }

  if (document.querySelector('.tile-logo')) {
    import('~scripts/blocks/tile-logo');
  }

  if (document.querySelector('.logo-ticker-block')) {
    import('~scripts/blocks/logo-ticker-tape');
  }

  if (document.querySelector('.js-values-block-mobile-slider')) {
    import('~scripts/blocks/values').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.js-google-map')) {
    import('./blocks/map/map');
    import('./global/google-maps-api').then(component => {
      component.default.outputScripTag();
    });
  }

  if (document.querySelector('.js-simple-accordion')) {
    import('~scripts/components/accordion/simple-accordion').then(component => {
      const SimpleAccordion = component.default;

      document.querySelectorAll('.js-simple-accordion').forEach(node => {
        new SimpleAccordion(node);
      });
    });
  }

  if (document.querySelector('.js-secondary-nav')) {
    import('~scripts/blocks/subnav');
  }

  if (document.querySelector('.js-related-articles')) {
    import('~scripts/blocks/related-articles');
  }

}

function registerUtilities() {
  if (document.querySelector('.draggable')) {
    import('./utility/horizontal-drag').then(component => {
      component.default();
    });
  }

  // Form :: field validation feedback
  if ( document.querySelectorAll('.form-style').length ) {
    import('~scripts/components/form/form-field-validation-feedback').then(component => {
      const FormFieldValidationFeedback = component.default;
      FormFieldValidationFeedback.init('.form-style');
    });
  }

  if (document.querySelector('div[data-accordian-container]')) {
    import('./utility/accordion').then(component => {
      component.default();
    });
  }

  if (document.querySelector('.js-simple-slider')) {
    import('./utility/simple-slider').then(component => {
      const SimpleSlider = component.default;

      new SimpleSlider('.js-simple-slider', {
        slide: '.js-simple-slider-slide',
        slidesContainer: '.js-simple-slider-slides-container',
        prevBtn: '.js-simple-slider-prev-button',
        nextBtn: '.js-simple-slider-next-button'
      });
    });
  }
}

function registerOtherElements() {
  // Posts
  if (document.getElementById('feed')) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vue-vendor:loaded', () => {
      import('~scripts/blocks/feed');
    });

    import('./global/vendor-manager')
      .then(component => {
        component.default.outputScripTag();
      });
  }
}

document.addEventListener('DOMContentLoaded', registerBlocks);
document.addEventListener('DOMContentLoaded', registerUtilities);
document.addEventListener('DOMContentLoaded', registerOtherElements);
document.addEventListener('DOMContentLoaded', AOS.init);

// Functions
hamburger();
document.addEventListener('DOMContentLoaded', footerPosition('.navbar'));
window.addEventListener('resize', footerPosition('.navbar'));

// Borlabs Cookies

function initVideoOnConsent() 
{
  let canInitiate = false;
  if ( typeof window.BorlabsCookie === 'undefined' ) {
    canInitiate = true;
  } else if ( window.BorlabsCookie.Consents.hasConsentForServiceGroup('essential') ) {
    canInitiate = true;
  } else if (window.BorlabsCookie.Consents.hasConsent('vimeo')) {
    canInitiate = true;
  }

  // eslint-disable-next-line
  console.log('Inited with consent: ', canInitiate);

  if ( canInitiate ) {
    if ( document.querySelector('.js-video-player-autoplay') ) {
      import('~scripts/components/video/video-autoplay').then(component => {
        
        component.default.init();
      });
    }

    if ( document.querySelector('.js-video-player') ) {
      import('~scripts/components/video/video-player').then(component => {
        component.default.init();
      });
    }
  }
}

/**
 * Event :: observe video blocks
*/
window.addEventListener('borlabs-cookie-after-init', () => {
  initVideoOnConsent();
});

document.addEventListener('DOMContentLoaded', () => {
  initVideoOnConsent();
});

window.addEventListener('borlabs-cookie-consent-saved', () => {
  initVideoOnConsent();
});
